module.exports = __webpack_public_path__ + "img/image8.6837de0.webp";